import React from "react";
import _ from "lodash";
import { EuiFlexItem } from "@elastic/eui";
import TripDetailsSection from "../TripDetailsSection";


export default function SupplierDetails({
    label,
    supplierOptions,
    supplierName,
    onChange,
    isEditable,
    onConfirmingField,
    isConfirmed,
}) {

    return (
        <EuiFlexItem>
            <TripDetailsSection
                label={label}
                options={supplierOptions}
                selectedValue={_.startCase(supplierName)}
                onSelectChange={onChange}
                isEditable={isEditable}
                onConfirmingField={onConfirmingField}
                isConfirmed={isConfirmed}
            />
        </EuiFlexItem>
    );
}
